import Logger from '@/lib/logger';
import { LoanTypeService } from '@/modules/global-settings/loan-origination/services/loan-policies/loan-type.service';
import { make } from 'vuex-pathify';
// Instantiate the service
const loanTypeService = new LoanTypeService();
// Define the state
export const state = {
  loanTypes: []
};
// Define the mutations
export const mutations = {
  ...make.mutations(state)
};
// Define the actions
export const actions = {
  /**
   * Fetch all loan types
   * @async
   * @param {object} context - The store context
   * @returns {number} status - The status code
   * @private This will update the state with the fetched loan types
   */
  async fetchLoanTypes({ commit }) {
    try {
      const result = await loanTypeService.fetchLoanTypes();
      if (result.status == 200) {
        commit('SET_LOAN_TYPES', result.data);
      }
      return result.status;
    } catch (error) {
      Logger.error('getting loan types failed', error);
    }
  },

  /**
   * Create a loan type
   * @async
   * @param {object} context - The store context
   * @param {object} loanType - The loan type to create
   * @returns {number} status - The status code
   * @private This will refetch the loan types
   */
  async createLoanType({ dispatch }, loanType) {
    try {
      const result = await loanTypeService.createLoanType(loanType);
      if (result.status == 201) {
        dispatch('fetchLoanTypes');
      }
      return result.status;
    } catch (error) {
      Logger.error('creating loan type failed', error);
    }
  },

  /**
   * Update a loan type
   * @async
   * @param {object} context - The store context
   * @param {Object} payload - The payload object
   * @param {string} payload.id - The loan type id
   * @param {object} payload.updates - The updates to apply
   * @returns {number} status - The status code
   * @private This will refetch the loan types
   */
  async updateLoanType({ dispatch }, { id, updates }) {
    try {
      const result = await loanTypeService.updateLoanType(id, updates);
      if (result.status == 200) {
        dispatch('fetchLoanTypes');
      }
      return result.status;
    } catch (error) {
      Logger.error('updating loan type failed', error);
    }
  },

  /**
   * Delete a loan type
   * @async
   * @param {object} context - The store context
   * @param {string} id - The loan type id
   * @returns {number} status - The status code
   * @private This will refetch the loan types
   */
  async deleteLoanType({ dispatch }, id) {
    try {
      const result = await loanTypeService.deleteLoanType(id);
      if (result.status == 200) {
        dispatch('fetchLoanTypes');
      }
      return result.status;
    } catch (error) {
      Logger.error('deleting loan type failed', error);
    }
  }
};
